import React, { useEffect, useState, Fragment } from "react";
import ActionButton from "../general/ActionButton";
import { getProvinceInformation } from "../store/broker";
import { useDispatch } from "react-redux";
import Select from "react-dropdown-select";
import "./brokerage.css";
import {
  getBrokerageInformation,
  updateDetails,
  getDetails,
  getIsUpdating,
  getUpdateErrors,
  getAddressStatus,
  toggleAddressModal,
  addBranch,
  deleteBranch,
} from "../store/brokerage";
import { useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import { Switch } from "@material-ui/core";
import EditIconOutlined from "@material-ui/icons/CreateOutlined";
import PerfectScrollbar from "react-perfect-scrollbar";
import Modal from "react-modal";
import * as theme from "../theme";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import translations from "../utils/translations";

const BrokerageDetails = () => {
  return (
    <BrokerageDetailsPane>{/* <ToastContainer /> */}</BrokerageDetailsPane>
  );
};

const BrokerageDetailsPane = () => {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  return (
    <div
      style={{
        margin: "3.5rem",
        // marginTop: "3rem",
        // marginBottom: "14rem",
      }}
    >
      <h5
        className="px-2"
        style={{
          fontFamily: "GibsonSemiBd",
          justifyContent: "center",
          fontSize: "1.2vw",
        }}
      >
        {translations[languagepreference].brokerageAdmin.brokerageSummary}
      </h5>
      <BrokerageDetailItems />
    </div>
  );
};

const BrokerageDetailItems = () => {
  const provinces = useSelector(getProvinceInformation);
  const [provinceValue, setProvinceValue] = useState([]);
  const [select, setSelect] = useState("");
  const [name, setName] = useState(null);
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [postalcode, setPostalCode] = useState(null);
  const [website, setWebsite] = useState(null);
  const [phone, setPhone] = useState(null);
  const [isFullApp, setisFullApp] = useState(null);
  const [invoiceEmail, setInvoiceEmail] = useState([""]);
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  const translationsBrokerAdmin =
    translations[languagepreference].brokerageAdmin;
  const onProvinceHandle = (value) => {
    setProvince(value[0].code);
  };
  const dispatch = useDispatch();
  const onAddAddressClickHandle = (value) => {
    dispatch(toggleAddressModal(value));
  };

  const handleChange = (index, event) => {
    const values = [...invoiceEmail];
    values[index] = event.target.value;
    setInvoiceEmail(values);
  };

  const handleRemoveField = (index) => {
    const values = [...invoiceEmail];
    values.splice(index, 1);
    setInvoiceEmail(values);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const validateEmptyFields = () => {
    return invoiceEmail.some((email) => email.trim() === "");
  };

  useEffect(() => {
    setProvinceValue(provinces.provinces);
  }, [provinces]);
  useEffect(() => {
    dispatch(getDetails());
  }, []);

  let information = useSelector(getBrokerageInformation);
  let addressModalState = useSelector(getAddressStatus);
  let isUpdating = useSelector(getIsUpdating);
  let updateErrors = useSelector(getUpdateErrors);
  useEffect(() => {
    if (information?.address != undefined && information.address) {
      let data = false;
      let name = provinces.provinces.filter((prv) => {
        if (prv.code == information.address?.map((t) => t.province)) {
          let data = true;
          if (prv.code == information.address?.map((t) => t.province))
            setSelect(prv.name);
        }
      });
    }
  }, [information]);
  useEffect(() => {
    if (information.forwardinvoiceemailids) {
      setInvoiceEmail(information.forwardinvoiceemailids);
    }
    if(information.isfullapp != undefined){
      setisFullApp(information.isfullapp)
    }
  }, [information]);
  const code = information.code;
  const handleAddField = () => {
    const isValid = invoiceEmail.every(
      (email) => validateEmail(email) && email.trim() !== ""
    );
    if (isValid) {
      const values = [...invoiceEmail];
      values.push("");
      setInvoiceEmail(values);
    } else {
      // Show validation error message or perform desired action
      console.log("Please fill in all email fields correctly");
    }
  };
  const handleUpdateData = () => {
    let data = {
      brokerage_code: code,
      brokerage_name: name,
      contact_number: phone,
      website: website,
      addr1: addr1,
      addr2: addr2,
      city: city,
      province: province,
      postal_code: postalcode,
      forwardinvoiceemailids: invoiceEmail,
      isFullApp,
    };

    const isValid = invoiceEmail.every(
      (email) => validateEmail(email) && email.trim() !== ""
    );
    if (isValid) {
      dispatch(updateDetails(data)).then(
        setTimeout(() => {
          Array.isArray(updateErrors) && !updateErrors.length
            ? toast.success("Updated Successfully")
            : toast(updateErrors);
        }, 100)
      );
    } else {
      toast.success("Please fill in all email fields correctly");
    }
  };
  return (
    <div style={{ fontFamily: "GibsonRegular", fontSize: "0.8vw" }}>
      <form className="m-4">
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.brokerageName}
          </label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtName"
              placeholder="Enter Brokerage name"
              onChange={(event) => {
                setName(event.target.value);
              }}
              defaultValue={information.name}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.primaryAddress}
          </label>
          <div className="col-sm-10">
            <input
              className="form-control my-2"
              id="txtAdd1"
              placeholder="Enter Brokerage Address 1"
              onChange={(event) => {
                setAddr1(event.target.value);
              }}
              defaultValue={
                information.address ? information.address[0].addr_line1 : ""
              }
            />
            <input
              className="form-control my-2"
              id="txtAdd2"
              placeholder="Enter Brokerage Address 2"
              onChange={(event) => {
                setAddr2(event.target.value);
              }}
              defaultValue={
                information.address ? information.address[0].addr_line2 : ""
              }
            />
            <input
              className="form-control my-2"
              id="txtCity"
              placeholder="Enter Brokerage City"
              onChange={(event) => {
                setCity(event.target.value);
              }}
              defaultValue={
                information.address ? information.address[0].city : ""
              }
            />
            <Select
              placeholder={select}
              color={theme.COLORS.primary_navyblue}
              searchable={true}
              onChange={(values) => onProvinceHandle(values)}
              values={[]}
              options={provinceValue}
              style={{
                width: "100%",
                height: "5vh",
                fontSize: "1.9vmin",
                border: "5px solid white",
                borderRadius: 15,
                fontFamily: "GibsonRegular",
              }}
              labelField={"name"}
              valueField={"code"}
              dropdownHeight={"58vh"}
            />
            <input
              className="form-control my-2"
              id="txtPostalCode"
              placeholder="Enter Brokerage Postal Code"
              onChange={(event) => {
                setPostalCode(event.target.value);
              }}
              defaultValue={
                information.address ? information.address[0].postal_code : ""
              }
            />
            <div style={{ width: "20%", float: "right" }}>
              <Button
                style={{
                  color: "white",
                  height: "3.5vh",
                  fontFamily: "GibsonSemiBd",
                  fontSize: 12,
                  backgroundColor: theme.COLORS.secondary_skyblue,
                  marginTop: 5,
                  marginLeft: 10,
                  border: 0,
                  width: "9vw",
                  letterSpacing: 1,
                }}
                onClick={() => {
                  onAddAddressClickHandle(true);
                }}
              >
                {translationsBrokerAdmin.addAnotherBranch}
              </Button>
            </div>
          </div>
        </div>
        {/* invoice-emails form  */}
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.invoiceEmails}
          </label>
          <div className="col-sm-10">
            {invoiceEmail &&
              invoiceEmail.map((email, index) => (
                <div className="input-group" key={index}>
                  <input
                    type="text"
                    className={`form-control my-2 ${
                      !validateEmail(email) && email.trim() !== ""
                        ? "is-invalid"
                        : ""
                    }`}
                    placeholder="Enter Invoice Email"
                    onChange={(event) => handleChange(index, event)}
                    value={email}
                  />
                  {index !== 0 && (
                    <div className="text-center bg-danger delete-button">
                      <DeleteOutlineOutlinedIcon
                        type="button"
                        onClick={() => handleRemoveField(index)}
                      />
                    </div>
                  )}
                  {!validateEmail(email) && email.trim() !== "" && (
                    <div className="invalid-feedback">Invalid email</div>
                  )}
                </div>
              ))}
            <div className="text-center">
              <Button
                style={{
                  color: "white",
                  height: "3.5vh",
                  fontFamily: "GibsonSemiBd",
                  fontSize: 12,
                  backgroundColor: theme.COLORS.secondary_skyblue,
                  marginTop: 5,
                  border: 0,
                  width: "9vw",
                  letterSpacing: 1,
                }}
                type="button"
                onClick={handleAddField}
              >
                {translationsBrokerAdmin.addMore}
              </Button>
            </div>
            {validateEmptyFields() && (
              <div className="text-danger mt-2">
                Please fill in all email fields
              </div>
            )}
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.additionalBranches}
          </label>
          <div className="col-sm-10">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th scope="col"> {translationsBrokerAdmin.address1}</th>
                  <th scope="col">{translationsBrokerAdmin.address2}</th>
                  <th scope="col"> {translationsBrokerAdmin.city}</th>
                  <th scope="col"> {translationsBrokerAdmin.province}</th>
                  <th scope="col"> {translationsBrokerAdmin.postalCode}</th>
                  {/* <th scope="col"></th> */}
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {information.address ? (
                  information.address.slice(1).map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <tr scope="row">
                          <td> {item.addr_line1} </td>
                          <td> {item.addr_line2} </td>
                          <td> {item.city} </td>
                          <td> {item.province} </td>
                          <td style={{ width: "150px" }}>
                            {" "}
                            {item.postal_code}{" "}
                          </td>
                          <td
                            className="text-center bg-danger"
                            style={{
                              width: "50px",
                              padding: 5,
                              borderRadius: 20,
                              color: "white",
                            }}
                          >
                            <DeleteOutlineOutlinedIcon
                              onClick={() => {
                                let data = {
                                  brokerage_code: code,
                                  addr_line1: item.addr_line1,
                                  addr_line2: item.addr_line2,
                                  city: item.city,
                                  province: item.province,
                                  postal_code: item.postal_code,
                                };
                                dispatch(deleteBranch(data)).then(
                                  setTimeout(() => {
                                    dispatch(getDetails());
                                    Array.isArray(updateErrors) &&
                                    !updateErrors.length
                                      ? toast.success(
                                          "Branch Deletion Successful"
                                        )
                                      : toast(updateErrors);
                                  }, 100)
                                );
                              }}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })
                ) : (
                  <tr key={"0"}>
                    <td colSpan="6"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {" "}
            {translations[languagepreference].brokerageAdmin.website}
          </label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtWebsite"
              placeholder="Enter Brokerage Website"
              onChange={(event) => {
                setWebsite(event.target.value);
              }}
              defaultValue={information.website}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.contactNumber}
          </label>
          <div className="col-sm-10">
            <input
              className="form-control"
              id="txtPhone"
              placeholder="Enter Contact Number"
              onChange={(event) => {
                setPhone(event.target.value);
              }}
              defaultValue={information.contact_number}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-sm-2 col-form-label">
            {translations[languagepreference].brokerageAdmin.startApplicationFullAppMode}
          </label>
          <div className="col-sm-10">
            <Switch
              style={{
                fontFamily: "GibsonSemiBd",
                fontSize: "2.2vmin",
                color: theme.COLORS.secondary_skyblue,
              }}
              onChange={(e) => {
                  console.log("Switched ", e.target.checked)
                  setisFullApp(e.target.checked)
              }}
              checked={isFullApp}
            />
          </div>
        </div>
        <div style={{ width: "10%", float: "right" }}>
          <Button
            style={{
              color: "white",
              height: "3.5vh",
              fontFamily: "GibsonSemiBd",
              fontSize: 12,
              backgroundColor: theme.COLORS.secondary_skyblue,
              marginTop: 5,
              marginLeft: 10,
              border: 0,
              width: "5vw",
              letterSpacing: 1,
            }}
            onClick={handleUpdateData}
          >
            {isUpdating ? (
              <Spinner animation="border" size="sm" variant="light" />
            ) : (
              translationsBrokerAdmin.save
            )}
          </Button>
        </div>
      </form>

      <Modal
        size="md"
        isOpen={addressModalState}
        ariaHideApp={false}
        shouldCloseOnEsc={false}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          justifyContent: "center",
          content: {
            height: "50vh",
            width: "50vw",
            position: "absolute",
            top: "15vh",
            left: "25vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.primary_navyblue,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
          },
        }}
      >
        <AddressBox code={code} />
      </Modal>
    </div>
  );
};

const AddressBox = (props) => {
  const provinces = useSelector(getProvinceInformation);
  useEffect(() => {
    if (provinces) {
      setProvinceValue(provinces.provinces);
    }
  }, [provinces]);
  const [provinceValue, setProvinceValue] = useState([]);
  const code = props.code;
  const [addr1, setAddr1] = useState(null);
  const [addr2, setAddr2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [postalcode, setPostalCode] = useState(null);
  const isUpdating = useSelector(getIsUpdating);
  const updateErrors = useSelector(getUpdateErrors);
  const dispatch = useDispatch();
  const onProvinceHandle = (value) => {
    setProvince(value[0].code);
  };
  const onAddButtonClick = () => {
    let data = {
      brokerage_code: code,
      addr_line1: addr1,
      addr_line2: addr2,
      city: city,
      province: province,
      postal_code: postalcode,
    };
    dispatch(addBranch(data)).then(
      setTimeout(() => {
        dispatch(getDetails());
        Array.isArray(updateErrors) && !updateErrors.length
          ? toast.success("Branch Added Successfully")
          : toast(updateErrors);
      }, 100)
    );
    dispatch(toggleAddressModal(false));
  };

  const onCancelButtonClick = (value) => {
    dispatch(toggleAddressModal(value));
  };

  return (
    <PerfectScrollbar>
      <div>
        <form className="m-4">
          <h3
            className="text-center m-3"
            style={{
              fontFamily: "GibsonSemiBd",
              justifyContent: "center",
              fontSize: "1.2vw",
            }}
          >
            Enter Address Details
          </h3>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Address 1</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtAddress1"
                placeholder="Enter Address Line 1"
                onChange={(event) => {
                  setAddr1(event.target.value);
                }}
                defaultValue={props.addr1}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Address 2</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtAddress2"
                placeholder="Enter Address Line 2"
                onChange={(event) => {
                  setAddr2(event.target.value);
                }}
                defaultValue={props.addr2}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">City</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtCity"
                placeholder="Enter City"
                onChange={(event) => {
                  setCity(event.target.value);
                }}
                defaultValue={props.city}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Province</label>
            <div className="col-sm-10">
              <Select
                placeholder={"Select Province"}
                color={theme.COLORS.primary_navyblue}
                searchable={true}
                onChange={(values) => onProvinceHandle(values)}
                values={[]}
                options={provinceValue}
                style={{
                  width: "100%",
                  height: "5vh",
                  fontSize: "1.9vmin",
                  border: "5px solid white",
                  borderRadius: 15,
                  fontFamily: "GibsonRegular",
                }}
                labelField={"name"}
                valueField={"code"}
                dropdownHeight={"58vh"}
              />
            </div>
          </div>
          <div
            className="form-group row"
            style={{
              fontFamily: "GibsonRegular",
              justifyContent: "center",
              fontSize: "1vw",
            }}
          >
            <label className="col-sm-2 col-form-label">Postal Code</label>
            <div className="col-sm-10">
              <input
                className="form-control"
                id="txtPostalCode"
                placeholder="Enter Postal Code"
                onChange={(event) => {
                  setPostalCode(event.target.value);
                }}
                defaultValue={props.postalcode}
              />
            </div>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onAddButtonClick();
              }}
            >
              {isUpdating ? (
                <Spinner animation="border" size="sm" variant="light" />
              ) : (
                "Add"
              )}
            </Button>
          </div>
          <div className="m-2" style={{ width: "10%", float: "right" }}>
            <Button
              style={{
                color: "white",
                height: "3.5vh",
                fontFamily: "GibsonSemiBd",
                fontSize: 12,
                backgroundColor: theme.COLORS.secondary_skyblue,
                marginTop: 5,
                marginLeft: 10,
                border: 0,
                width: "5vw",
                letterSpacing: 1,
              }}
              onClick={() => {
                onCancelButtonClick(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </PerfectScrollbar>
  );
};

export default BrokerageDetails;
